import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";


import Landing from "./Pages/landing";
import AboutUs from "./Pages/aboutUs";
import Team from "./Pages/team";
import Sustainability from "./Pages/sustainability";
import ContactUs from "./Pages/contactUs";
import WrapAndEnsembles from "./Pages/wrapAndEnsembles";
import GiftBags from "./Pages/giftBags";
import GiftBoxes from "./Pages/giftBoxes";
import GreetingCards from "./Pages/greetingCards";
import GiftBows from "./Pages/giftBows";
import CelloWraps from "./Pages/celloWraps";
import GiftTags from "./Pages/giftTags";
import Partyware from "./Pages/partyware";
import './App.css';


function App() {
  document.title = "GlitterpaperDesigns";
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/team" element={<Team />} />
          <Route path="/sustainability" element={<Sustainability />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/product/wrap-and-ensembles" element={<WrapAndEnsembles />} />
          <Route path="/product/gift-bags" element={<GiftBags />} />
          <Route path="/product/gift-boxes" element={<GiftBoxes />} />
          <Route path="/product/greeting-cards" element={<GreetingCards />} />
          <Route path="/product/gift-bows" element={<GiftBows />} />
          <Route path="/product/cello-gift-wrap" element={<CelloWraps />} />
          <Route path="/product/gift-tag" element={<GiftTags />} />
          <Route path="/product/partyware" element={<Partyware />} />
        </Routes>
      </Router>
	</div>
  );
}

export default App;
